import {IConfigurationDashboardData} from '../components/dashboard/dashboard-library-header-main/import-dashboards-window/models/configuration-dashboard.props';

export const checkStructure = (props: IConfigurationDashboardData): boolean => {
  const structure: IConfigurationDashboardData = {
    id: props.id,
    name: props.name,
    description: props.description,
    shared: props.shared,
    widgets: props.widgets,
    imageOption: props.imageOption,
    defaultImage: props.defaultImage,
  };

  let objectsAreSame = true;
  for (const [, value] of Object.entries(structure)) {
    const test = value;
    if (test === undefined) {
      objectsAreSame = false;
      break;
    }
  }
  return objectsAreSame;
};
